import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-110px; text-center" }, "Nama"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Jumlah Siswa"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Sales"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Implementator"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Status Migrasi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-2" }, "Aksi")
  ])
], -1)
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_12 = {
  key: 1,
  class: "badge badge-light"
}
const _hoisted_13 = {
  key: 2,
  class: "badge badge-secondary"
}
const _hoisted_14 = {
  key: 3,
  class: "badge badge-info"
}
const _hoisted_15 = {
  key: 4,
  class: "badge badge-warning"
}
const _hoisted_16 = {
  key: 5,
  class: "badge badge-danger"
}
const _hoisted_17 = {
  key: 6,
  class: "badge badge-success"
}
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_20 = {
  key: 1,
  class: "badge badge-secondary"
}
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.tableData.name), 1),
                _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.tableData.studentCount), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.tableData.salesAreaName), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.tableData.listImplementatorName), 1),
                _createElementVNode("td", _hoisted_10, [
                  (_ctx.tableData.status == 'Leads')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Leads "))
                    : _createCommentVNode("", true),
                  (_ctx.tableData.status == 'Waiting')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Menunggu "))
                    : _createCommentVNode("", true),
                  (_ctx.tableData.status == 'Process')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, " Proses "))
                    : _createCommentVNode("", true),
                  (_ctx.tableData.status == 'Closing')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, " Closing "))
                    : _createCommentVNode("", true),
                  (_ctx.tableData.status == 'Pending')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, " Pending "))
                    : _createCommentVNode("", true),
                  (_ctx.tableData.status == 'Cancel')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, " Batal "))
                    : _createCommentVNode("", true),
                  (_ctx.tableData.status == 'Live')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, " Live "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_18, [
                  (_ctx.tableData.isMigratePsp === true )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Sudah "))
                    : _createCommentVNode("", true),
                  (_ctx.tableData.isMigratePsp === false )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, " Belum "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("a", {
                    class: "symbol symbol-35px me-2",
                    "data-bs-toggle": "tooltip",
                    title: "Detail",
                    style: {"cursor":"pointer"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/sekolah/sekolah/detail/' + _ctx.tableData._id)))
                  }, _hoisted_23),
                  _createElementVNode("a", {
                    class: "symbol symbol-35px me-2",
                    "data-bs-toggle": "tooltip",
                    title: "Edit",
                    style: {"cursor":"pointer"},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/sekolah/sekolah/edit/' + _ctx.tableData._id)))
                  }, _hoisted_25)
                ])
              ])
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}